import { makeObservable } from 'mobx';
import isUndefined from 'lodash/isUndefined';

import type { DrugData } from 'chaika-frontend-types/frontend-cms';

import { List } from '@store/abstract/List';
import { DateHelper } from '@utils/DateHelper';

import { Drug } from './Drug';

export interface DrugFilterParams {
    ids?: string[];
    isNotDeleted?: boolean;
    end?: Date;
    ehrId?: string;
    parentEntryId?: string;
}

export class DrugList extends List<Drug, DrugData, DrugFilterParams> {
    constructor(drugs: DrugData[] = []) {
        super();
        makeObservable(this);

        this.filterParams = {
            end: new Date(),
            isNotDeleted: true,
        };

        this.set(drugs);
    }

    public update(id: string, updateParams: Partial<DrugData>) {
        const current = this.getExisting(id);

        super.update(id, { ...current, ...updateParams });
    }

    public serialize(): DrugData[] {
        const drugs: DrugData[] = [];

        this.list.forEach(drug => {
            drugs.push(drug.serialize());
        });

        return drugs;
    }

    protected create(params: DrugData): Drug {
        return new Drug(params);
    }

    protected filterValue(drug: Drug, filterParams: DrugFilterParams): boolean {
        return (
            (!!drug.end && !!filterParams.end ? DateHelper.isBefore(filterParams.end, drug.end) : true) &&
            (!isUndefined(filterParams.ids) ? filterParams.ids.includes(drug.id) : true) &&
            (!isUndefined(filterParams.parentEntryId) ? filterParams.parentEntryId === drug.parentEntryId : true) &&
            (!isUndefined(filterParams.ehrId) ? filterParams.ehrId === drug.ehrId : true)
        );
    }
}
